import {Component, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {UserSelectionComponent} from "../../user-select/user-selection.component";

@Component({
  templateUrl: "./select-project-users.template.pug",
})
export class SelectProjectUsersComponent extends WorkflowStep {
  @ViewChild("userSelection")
  userSelection: UserSelectionComponent;

  ready() {
    if (this.userSelection.complete && !this.userSelection.error) {
      this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
    }
  }

  async autoSave(): Promise<boolean> {
    const result = await this.userSelection.save();

    if (!result) return false;

    if (this.userSelection.complete && !this.userSelection.error) {
      await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
      return true;
    }

    return false;
  }

  checkDirty(): boolean {
    return this.userSelection.dirty;
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
  ) {
    super();
  }
}
